/**
 * @description  generates a version 4 UUID,
 * which means that it uses random or pseudo-random numbers as part of its creation process
 * @example 123e4567-e89b-12d3-a456-426614174000
 */
export const generateIdentifierUuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
